<template>
    <div
        :style="{
            'margin-left': '-12px',
            'margin-right': '-12px'
        }"
    >
        <carousel
            :per-page="1"
            :loop="true"
            :pagination-padding="5"
            :pagination-size="8"
            :navigation-enabled="true"
            navigation-next-label=""
            navigation-prev-label=""
            pagination-position="bottom-overlay"
            pagination-color="#fff"
            pagination-active-color="#fff"
        >
            <slide
                v-for="(image, index) in images"
                :key="index"
                :style="{
                    'padding-left': '12px',
                    'padding-right': '12px'
                }"
            >
                <div class="relative w-full aspect-ratio-4/3 md:aspect-ratio-16/6 3xl:aspect-ratio-16/9">
                    <div
                        :style="{
                            'background-image': 'url(' + image.url + ')'
                        }"
                        class="absolute inset-0 h-full bg-white bg-center bg-cover rounded bg-grey-lightest"
                    />

                    <a
                        v-if="image.can_zoom"
                        :href="image.url"
                        class="absolute top-0 right-0 p-3 mx:p-6"
                        target="_blank"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="12"
                                fill="black"
                                fill-opacity="0.4"
                            />

                            <path
                                d="M15.2 14.3126L15.8875 15.0001C16.1375 14.9876 16.4062 15.0813 16.6 15.2751L18.475 17.1501C18.6406 17.3278 18.7307 17.5628 18.7264 17.8057C18.7221 18.0486 18.6238 18.2803 18.452 18.4521C18.2802 18.6239 18.0485 18.7222 17.8056 18.7265C17.5627 18.7308 17.3277 18.6407 17.15 18.4751L15.275 16.6001C15.1817 16.5072 15.109 16.3958 15.0616 16.2731C15.0142 16.1503 14.9932 16.019 15 15.8876L14.3125 15.2001C13.3079 15.9804 12.0437 16.3486 10.7772 16.2295C9.51077 16.1105 8.3373 15.5132 7.49574 14.5594C6.65418 13.6055 6.20783 12.3667 6.24756 11.0953C6.28729 9.82388 6.81012 8.6154 7.70959 7.71593C8.60906 6.81646 9.81753 6.29364 11.089 6.25391C12.3604 6.21418 13.5991 6.66053 14.553 7.50209C15.5069 8.34364 16.1041 9.51712 16.2232 10.7836C16.3422 12.05 15.9741 13.3143 15.1937 14.3188L15.2 14.3126ZM11.25 15.0001C12.2445 15.0001 13.1984 14.605 13.9016 13.9017C14.6049 13.1985 15 12.2446 15 11.2501C15 10.2555 14.6049 9.30167 13.9016 8.59841C13.1984 7.89515 12.2445 7.50006 11.25 7.50006C10.2554 7.50006 9.30157 7.89515 8.59831 8.59841C7.89505 9.30167 7.49996 10.2555 7.49996 11.2501C7.49996 12.2446 7.89505 13.1985 8.59831 13.9017C9.30157 14.605 10.2554 15.0001 11.25 15.0001ZM11.875 10.6251H13.125C13.2907 10.6251 13.4497 10.6909 13.5669 10.8081C13.6841 10.9253 13.75 11.0843 13.75 11.2501C13.75 11.4158 13.6841 11.5748 13.5669 11.692C13.4497 11.8092 13.2907 11.8751 13.125 11.8751H11.875V13.1251C11.875 13.2908 11.8091 13.4498 11.6919 13.567C11.5747 13.6842 11.4157 13.7501 11.25 13.7501C11.0842 13.7501 10.9252 13.6842 10.808 13.567C10.6908 13.4498 10.625 13.2908 10.625 13.1251V11.8751H9.37496C9.2092 11.8751 9.05023 11.8092 8.93302 11.692C8.81581 11.5748 8.74996 11.4158 8.74996 11.2501C8.74996 11.0843 8.81581 10.9253 8.93302 10.8081C9.05023 10.6909 9.2092 10.6251 9.37496 10.6251H10.625V9.37506C10.625 9.2093 10.6908 9.05033 10.808 8.93312C10.9252 8.81591 11.0842 8.75006 11.25 8.75006C11.4157 8.75006 11.5747 8.81591 11.6919 8.93312C11.8091 9.05033 11.875 9.2093 11.875 9.37506V10.6251Z"
                                fill="white"
                            />
                        </svg>
                    </a>
                </div>
            </slide>
        </carousel>
    </div>
</template>

<style>
    .VueCarousel-dot-container {
        display: flex !important;
        justify-content: center;
        align-items: center;
        padding-bottom: 16px !important;
    }

    .VueCarousel-dot {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.12);
        outline: none !important;
        padding: 0 !important;
        margin-right: 6px;
    }

    .VueCarousel-dot:last-child {
        margin-right: 0;
    }

    .VueCarousel-dot--active {
        width: 12px !important;
        height: 12px !important;
    }

    .VueCarousel-navigation {
        z-index: 1;
    }

    .VueCarousel-navigation-prev {
        left: 50px !important;
    }

    .VueCarousel-navigation-next {
        right: 50px !important;
    }

    .VueCarousel-navigation-prev,
    .VueCarousel-navigation-next {
        padding: 0 !important;
        top: auto !important;
        bottom: -12px;
    }

    .VueCarousel-navigation-prev:focus,
    .VueCarousel-navigation-next:focus {
        outline: none !important;
    }

    .VueCarousel-navigation-next::after {
        content: url("data:image/svg+xml,%3Csvg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='12' r='12' fill='black' fill-opacity='0.4'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.25701 8.85713C9.1424 8.77117 9.04759 8.66158 8.97901 8.53578C8.91043 8.40999 8.86969 8.27093 8.85953 8.12802C8.84937 7.98511 8.87004 7.84168 8.92014 7.70745C8.97024 7.57323 9.0486 7.45133 9.14991 7.35002C9.25122 7.24871 9.37311 7.17036 9.50734 7.12026C9.64157 7.07016 9.78499 7.04949 9.9279 7.05964C10.0708 7.0698 10.2099 7.11055 10.3357 7.17913C10.4615 7.2477 10.5711 7.34251 10.657 7.45713L14.657 11.4571C14.8402 11.6441 14.9429 11.8954 14.9429 12.1571C14.9429 12.4189 14.8402 12.6702 14.657 12.8571L10.657 16.8571C10.4644 17.0016 10.2262 17.0717 9.98612 17.0546C9.74602 17.0375 9.52012 16.9344 9.34991 16.7642C9.1797 16.594 9.07659 16.3681 9.05953 16.128C9.04247 15.8879 9.11258 15.6497 9.25701 15.4571L12.537 12.1571L9.23701 8.85713L9.25701 8.85713Z' fill='white'/%3E%3C/svg%3E%0A");
    }

    .VueCarousel-navigation-prev::after {
        content: url("data:image/svg+xml,%3Csvg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='13' r='12' transform='rotate(-180 12 13)' fill='black' fill-opacity='0.4'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14.743 16.1429C14.8576 16.2288 14.9524 16.3384 15.021 16.4642C15.0896 16.59 15.1303 16.7291 15.1405 16.872C15.1506 17.0149 15.13 17.1583 15.0799 17.2925C15.0298 17.4268 14.9514 17.5487 14.8501 17.65C14.7488 17.7513 14.6269 17.8296 14.4927 17.8797C14.3584 17.9298 14.215 17.9505 14.0721 17.9404C13.9292 17.9302 13.7901 17.8895 13.6643 17.8209C13.5385 17.7523 13.4289 17.6575 13.343 17.5429L9.34299 13.5429C9.15976 13.3559 9.05713 13.1046 9.05713 12.8429C9.05713 12.5811 9.15976 12.3298 9.34299 12.1429L13.343 8.14287C13.5356 7.99844 13.7738 7.92832 14.0139 7.94539C14.254 7.96245 14.4799 8.06555 14.6501 8.23576C14.8203 8.40598 14.9234 8.63187 14.9405 8.87198C14.9575 9.11209 14.8874 9.3503 14.743 9.54287L11.463 12.8429L14.763 16.1429L14.743 16.1429Z' fill='white'/%3E%3C/svg%3E%0A");
    }
</style>

<script>
    import { Carousel, Slide } from 'vue-carousel'

    export default {
        components: {
            Carousel,
            Slide
        },
        props: {
            images: {
                type: Array,
                required: true
            }
        }
    }
</script>
